module.exports = __webpack_public_path__ + "static/media/vote-nay.f7b2995b.svg";